import { configureStore } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import apiSlice from './api/api.slice';
import authReducer from './auth/auth.slice';
import gloablReducer from './global/global.slice';
import projectEditorReducer from './post/post.slice';

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    global: gloablReducer,
    projectEditor: projectEditorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});
// concat api slice middleware here
// dev tools based on env

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
